/* Eigen kleur- en maatkiezer (snippets/variant-swatches.liquid).
   Het thema (theme.js) kiest de variant en wisselt prijs, foto, knop en URL via de inputs met
   data-variant-input. Dit script houdt alleen de weergave bij: welke staal gekozen is, de
   kleurnaam naast het label, en wat uitverkocht is. Uitverkocht gaat per niveau, zoals
   Swatch King het deed: een waarde is op als er geen leverbare variant is met dezelfde
   keuzes in de opties ervoor en deze waarde. */
(function () {
  'use strict';

  function variantsOf(root) {
    if (!root._vsVariants) {
      var el = root.querySelector('[data-sw-variants]');
      try { root._vsVariants = JSON.parse(el.textContent); } catch (e) { root._vsVariants = []; }
    }
    return root._vsVariants;
  }

  function sync(root) {
    var groups = root.querySelectorAll('[data-sw-group]');
    var chosen = [];
    for (var g = 0; g < groups.length; g++) {
      var checked = groups[g].querySelector('input[data-variant-input]:checked');
      chosen.push(checked ? checked.value : null);
    }
    var variants = variantsOf(root);

    for (var i = 0; i < groups.length; i++) {
      var items = groups[i].querySelectorAll('[data-sw-item]');
      for (var k = 0; k < items.length; k++) {
        var item = items[k];
        var input = item.querySelector('input');
        var value = input.value;
        item.classList.toggle('is-selected', input.checked);

        var ok = false;
        for (var v = 0; v < variants.length && !ok; v++) {
          var av = variants[v][0], opts = variants[v][1];
          if (!av || opts[i] !== value) { continue; }
          var match = true;
          for (var p = 0; p < i; p++) {
            if (chosen[p] !== null && opts[p] !== chosen[p]) { match = false; break; }
          }
          ok = match;
        }
        item.classList.toggle('is-unavailable', !ok);
      }
      var label = groups[i].querySelector('[data-sw-value]');
      if (label && chosen[i] !== null) { label.textContent = chosen[i]; }
    }
  }

  function syncAll() {
    var roots = document.querySelectorAll('[data-sw-root]');
    for (var r = 0; r < roots.length; r++) { sync(roots[r]); }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var root = t.closest('[data-sw-root]');
    if (root) { sync(root); }
  });

  // Een variant kan ook van buitenaf wisselen (vaste koopknop, terugknop van de browser).
  document.addEventListener('variant:change', function () { setTimeout(syncAll, 0); });
  window.addEventListener('pageshow', syncAll);
})();
